import React from "react";
import {Link} from "react-router-dom"
import finance_case_study from "../../assets/img/369.jpg";
import { useNavigate } from "react-router-dom";
import {
  HiOutlineCog,
  HiOutlineDesktopComputer,
  HiOutlineClipboardList,
  HiOutlineUserGroup,
  HiOutlineArrowRight,
} from "react-icons/hi";


export default function Section5() {
  return (
    <div className="w-full p-6">
      <div className="bg-white border border-gray-200 h-full rounded-xl shadow-lg overflow-hidden flex flex-col">
        <div>
          <img
            src={finance_case_study}
            alt="Finance Case Study"
            className="w-full h-52 object-cover"
          />
        </div>
        <div className="p-8 flex flex-col flex-grow justify-between">
          <div>
            <div className="uppercase tracking-wide text-sm text-indigo-500 font-semibold">
              Case Study
            </div>
            <h2 className="mt-2 text-xl font-bold text-gray-900 dark:text-white">
              Transforming Enterprise Security with AI-Driven IAM Solutions
            </h2>
            <p className="mt-2 text-gray-600 dark:text-gray-300">
              AeroAegis Enhances Enterprise Security with AI-Powered Identity and Access Management (IAM)
            </p>
            <div className="mt-4 flex flex-wrap gap-4">
              <span className="inline-flex items-center rounded-md bg-blue-50 dark:bg-blue-900/20 px-2 py-1 text-xs font-medium text-blue-700 dark:text-blue-300 ring-1 ring-inset ring-blue-700/10 dark:ring-blue-300/20">
                <HiOutlineCog className="mr-1 h-3 w-3" />
                AI-Powered Identity Security
              </span>
              <span className="inline-flex items-center rounded-md bg-green-50 dark:bg-green-900/20 px-2 py-1 text-xs font-medium text-green-700 dark:text-green-300 ring-1 ring-inset ring-green-600/20 dark:ring-green-300/20">
                <HiOutlineDesktopComputer className="mr-1 h-3 w-3" />
                Intelligent Access Control
              </span>
              <span className="inline-flex items-center rounded-md bg-yellow-50 dark:bg-yellow-900/20 px-2 py-1 text-xs font-medium text-yellow-800 dark:text-yellow-300 ring-1 ring-inset ring-yellow-600/20 dark:ring-yellow-300/20">
                <HiOutlineClipboardList className="mr-1 h-3 w-3" />
                Compliance Automation
              </span>
              <span className="inline-flex items-center rounded-md bg-red-50 dark:bg-red-900/20 px-2 py-1 text-xs font-medium text-red-700 dark:text-red-300 ring-1 ring-inset ring-red-600/20 dark:ring-red-300/20">
                <HiOutlineUserGroup className="mr-1 h-3 w-3" />
                Zero Trust Security Model
              </span>
            </div>

            <div className="mt-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Key Outcomes:
              </h3>
              <ul className="mt-2 list-disc list-inside text-gray-600 dark:text-gray-300">
                <li>Enhanced Security and Risk Reduction</li>
                <li>Improved Operational Efficiency</li>
                <li>AI-Powered Compliance and Audit Readiness</li>
                <li>Cost Savings and Scalability</li>
              </ul>
            </div>
          </div>
          <div className="mt-6 flex justify-center">
            <Link 
              to="/enterprise-security"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Read Full Case Study
              <HiOutlineArrowRight className="ml-2 -mr-1 h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}